import firebase from "firebase";
import { db } from "./firebase";
import { fetchWorkerSnapshot } from "./workerInfo";

const WV_FORMS = "wvForms";
const IDEA_FORMS = "globalOpsSurvey";
const GLOBAL_FORMS = "globalAndroidSurvey";
const SENTINEL_COACH_FORM = "sentinelCoachSurvey";
const LOCATIONS = "locations";
const VEHICLE_INSPECTION_CHECKLIST_FORM = "vehicleInspectionChecklistForm";

export const saveWVForm = (data) => {
  return new Promise((resolve, reject) => {
    console.log(
      `
      driver-form 
      data received at backend 
      
      saveWVForm ${JSON.stringify(data)}
      `
    );

    db.collection(WV_FORMS)
      .add({
        ...data,
        actionTS: firebase.firestore.FieldValue.serverTimestamp(),
      })
      .then((doc) => resolve(doc.id))
      .catch((e) => reject(e));
  });
};

export const saveIdeaWVForm = (data) => {
  return new Promise((resolve, reject) => {
    console.log(
      `
      globalOpsSurvey-form 
      data received at backend 
      
      saveIdeaWVForm ${JSON.stringify(data)}
      `
    );

    db.collection(IDEA_FORMS)
      .add({
        ...data,
        actionTS: firebase.firestore.FieldValue.serverTimestamp(),
      })
      .then((doc) => resolve(doc.id))
      .catch((e) => reject(e));
  });
};

export const saveSentinelCoachWVForm = (data) => {
  return new Promise((resolve, reject) => {
    console.log(
      `
      sentinelCoachForm-form 
      data received at backend 
      
      saveSentinelCoachWVForm ${JSON.stringify(data)}
      `
    );

    db.collection(SENTINEL_COACH_FORM)
      .add({
        ...data,
        actionTS: firebase.firestore.FieldValue.serverTimestamp(),
      })
      .then((doc) => resolve(doc.id))
      .catch((e) => reject(e));
  });
};

export const saveVehicleInspectionChecklistForm = (data) => {
  return new Promise((resolve, reject) => {
    console.log(`outboundVehicleSupplierForm recieved at backened
      saveOutboundVehicleSupplierForm ${JSON.stringify(data)}`);
    db.collection(VEHICLE_INSPECTION_CHECKLIST_FORM)
      .add({
        ...data,
        actionTS: firebase.firestore.FieldValue.serverTimestamp(),
      })
      .then((doc) => resolve(doc.id))
      .catch((e) => reject(e));
  });
};
export const saveGlobalWVForm = (data) => {
  return new Promise((resolve, reject) => {
    console.log(
      `
      globalAndroidSurvey-form
      data received at backend 
      
      saveGlobalWVForm ${JSON.stringify(data)}
      `
    );

    db.collection(GLOBAL_FORMS)
      .add({
        ...data,
        actionTS: firebase.firestore.FieldValue.serverTimestamp(),
      })
      .then((doc) => resolve(doc.id))
      .catch((e) => reject(e));
  });
};

export const getDistricts = () => {
  return new Promise((resolve, reject) => {
    db.collection(LOCATIONS)
      .get()
      .then((snapshot) => {
        let districtMarketList = [];
        let uniqueDistricts = [];
        if (!snapshot.empty) {
          snapshot.forEach((doc) => {
            let docdata = doc.data();
            if (
              docdata.market &&
              docdata.market != "" &&
              docdata.transportEnabled == true
            ) {
              let districtName = docdata.districtName;
              const districtId = districtName.split("-");
              const districtMarket = districtId[0] + "-" + docdata.market;
              districtMarketList.push(districtMarket);
            }
          });
          uniqueDistricts.push([...new Set(districtMarketList)]);
        }
        resolve(uniqueDistricts);
      })
      .catch((e) => reject(e));
  });
};

/**
 * Resolve worker display name via HMAC workerInfo (no direct workers/{id} get).
 */
export const getUserName = async (id) => {
  return new Promise(async (resolve, reject) => {
    try {
      const snapshot = await fetchWorkerSnapshot(id);
      const emp = snapshot.exists ? snapshot.data() : null;
      let data;
      if (emp && (emp.firstName || emp.lastName)) {
        data =
          emp.firstName +
          " " +
          (emp.lastName ? emp.lastName : "");
      }
      resolve(data);
      console.log("data", data);
    } catch (e) {
      reject(e);
    }
  });
};
